import {Component, Input, OnInit} from "@angular/core";
import {DOCUMENT_TYPES, VALUE_TYPE} from "../../enums/enums";
import {RESTRICTION_TYPES, RESTRICTION_TYPES_LIST} from "../../enums/e-restrictions";
import {UI_TEXTS} from "../../enums/e-texts";
import * as _ from "underscore";
import {FactoryService} from "../../services/factory.service";
import {IArrayOfLevels, IRestriction, IArrayOfOfferLots} from "../../services/factory-service-impl/restriction.utils";
import {IOrdersRestrictionsGroup} from "../../definitions";
import {E_ENDPOINTS} from "../../helpers/params/loader-params";
import {paramsHelper} from "../../helpers/params-helper";
import {SEARCH_PROP_TYPES} from "../../enums/e-search";
import {CollectionService} from "../../services/collection.service";
import {IDocument} from "../../interfaces/document.definition";
import {WatchService} from "../../services/watch.service";
import {GO_CATEGORIES} from "../../enums/e-game-objects";
import {localeUtils} from "../../helpers/locale-utils";
import {BusService, INewDocumentEvent} from "../../services/bus.service";

@Component({
  selector: "nv-restriction",
  templateUrl: "./nv-restriction.component.html"
})


export class NvRestrictionComponent implements OnInit {
  UI_TEXTS = UI_TEXTS;

  restrictionTypes = RESTRICTION_TYPES;
  RESTRICTIONS = RESTRICTION_TYPES_LIST.sort(this.sortByLabel);
  VALUE_TYPE = VALUE_TYPE;
  inputSize: number;
  selectSize: number;

  payMonetaryGroups:IOrdersRestrictionsGroup[] = [];
  payRecencyGroups:IOrdersRestrictionsGroup[] = [];
  payFrequencyGroups:IOrdersRestrictionsGroup[] = [];
  ordersRestrictionsGroups:IDocument[];
  resourcesList:IDocument[];
  offersList:IDocument[];
  eventsList:IDocument[];
  offerLotsList:IDocument[];

  @Input() restriction: IRestriction;

  @Input() set small(v: boolean) {
    if (v) {
      this.resizeToSmallLayout();
    } else {
      this.resizeToNormalLayout();
    }
  }


  constructor(private factoryService: FactoryService,
              private collectionService: CollectionService,
              private  watchService: WatchService,
              private busService:BusService) {
    this.resizeToNormalLayout();
     this.busService.onDocumentUpdated
          .subscribe(
            e => this.updateOffersIfNeeded(e));
  }

  ngOnInit(){
    this.loadOffersRestrictionsGroups();
    this.loadResourcesList();
    this.loadOffersList();
    this.loadEventsList();
  }

  isValueAPrimitive() {
    return !this.isValueAnObject(); // just has to be not an object
  }


  isValueAnObject() {
    return _.isObject(this.restriction.value);
  }


  onRestrictionTypeChange() {
    this.factoryService.restrictionUtils.initializeParam(this.restriction);
  }

  getLocalizedName(doc:IDocument):string
  {
    return localeUtils.findName(doc);
  }

  getLotIdsByOfferId(offerId:number)
  {
    let result = [];
    for (let offer of this.offersList)
    {
      if (offer.id == offerId)
      {
        for (let id of offer['lotsIds'])
        {
          result.push({id:id});
        }
        return result;
      }
    }

    return [];
  }

  addOfferLotToRestriction(value:IArrayOfOfferLots)
  {
    value.lotsIds.push(0);
    this.watchService.notify();
  }

  removeOfferLotFromRestriction(value:IArrayOfOfferLots, i)
  {
    value.lotsIds.splice(i, 1);
    this.watchService.notify();
  }

  addLevelToRestriction(value:IArrayOfLevels)
    {
      value.levels.push(0);
      this.watchService.notify();
    }

    removeLevelFromRestriction(value:IArrayOfLevels, i)
    {
      value.levels.splice(i, 1);
      this.watchService.notify();
    }

  trackItemByIndex(index: number, value: any) {
    return index;
  }

  private sortByLabel(a, b):number
  {
    if (a.label > b.label)
    {
      return 1;
    }
    else if (a.label < b.label)
    {
      return -1;
    }
    return 0;
  }

  private resizeToSmallLayout() {
    this.selectSize = 12;
    this.inputSize = 6;
  }


  private resizeToNormalLayout() {
    this.selectSize = 0; // use default
    this.inputSize = 2;
  }

  private  loadResourcesList(){
    const search = paramsHelper
      .search()
      .addParam("category", SEARCH_PROP_TYPES.ENUM_MULTI, [GO_CATEGORIES.STUFF])
      .json;

    const params = paramsHelper
      .loader()
      .setEndpointApi()
      .setObjectType(DOCUMENT_TYPES.GO)
      .setNavParams(0, 9999)
      .setSearchParams(search);

    this.collectionService.loadChunkCached(params)
      .subscribe(
        r => {
          //console.log(r.documents);
          this.resourcesList = r.documents;
        });
  }

  private loadOffersList(){
    /*const search = paramsHelper
      .search()
      .addParam("_type", SEARCH_PROP_TYPES.ENUM_MULTI, [DOCUMENT_TYPES.OFFER])
      .json;*/

    const params = paramsHelper
      .loader()
      .setEndpointApi()
      .setObjectType(DOCUMENT_TYPES.OFFER)
      .setNavParams(0, 9999)
      /*.setSearchParams(search)*/;

    this.collectionService.loadChunkCached(params)
      .subscribe(
        r => {
          //console.log(r.documents);
          this.offersList = r.documents;
        });
  }

  private loadEventsList(){

      const params = paramsHelper
        .loader()
        .setEndpointApi()
        .setObjectType(DOCUMENT_TYPES.GAME_EVENT)
        .setNavParams(0, 9999)
        /*.setSearchParams(search)*/;

      this.collectionService.loadChunkCached(params)
        .subscribe(
          r => {
            //console.log(r.documents);
            this.eventsList = r.documents;
          });
    }

  private loadOffersRestrictionsGroups(){
    const params = paramsHelper
      .loader()
      .setEndpointId(E_ENDPOINTS.API)
      .setSearchParams(paramsHelper.search()
        .addParam("_type", SEARCH_PROP_TYPES.ENUM_MULTI,
          [DOCUMENT_TYPES.OFFERS_RESTRICTION_GROUP_RECENCY,
                 DOCUMENT_TYPES.OFFERS_RESTRICTION_GROUP_MONETARY,
                 DOCUMENT_TYPES.OFFERS_RESTRICTION_GROUP_FREQUENCY]).json
      )
      .setNavParams(0, 9999);

    this.collectionService.loadChunkCached(params)
      .subscribe(r => {
        this.ordersRestrictionsGroups = r.documents;
        //console.log(`loaded groups ${this.ordersRestrictionsGroups}`);
        for (let rg of this.ordersRestrictionsGroups)
        {
          if (rg._type == DOCUMENT_TYPES.OFFERS_RESTRICTION_GROUP_RECENCY)
          {
            this.payRecencyGroups.push(<IOrdersRestrictionsGroup>rg);
          }
          else if (rg._type == DOCUMENT_TYPES.OFFERS_RESTRICTION_GROUP_FREQUENCY)
          {
            this.payFrequencyGroups.push(<IOrdersRestrictionsGroup>rg);
          }
          else
          {
            this.payMonetaryGroups.push(<IOrdersRestrictionsGroup>rg);
          }
        }
      })
  }

  onInputChange() {
    this.watchService.notify();
  }

  getOfferLotsList(offerId){
    return this.offersList.find((offer) => {return offer.id == offerId})['lotsIds'];
  }

  updateOffersIfNeeded(e:INewDocumentEvent){
    //console.log(e);
    if (e.document != null && e.document._type == "offer"){
      this.loadOffersList();
    }
  }

}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-restrictions/nv-restriction.component.ts